<template>
	<b-modal
		id="cloneTemplateModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
	>
		<main>
			<header class="p-3">
				<div class="d-flex align-items-center justify-content-between w-100">
					<div class="modal-head">
						Clone Template
					</div>
					<div>
						<img
							class="pointer"
							src="../../../assets/projects-icons/x-close.svg"
							alt=""
						/>
					</div>
				</div>
			</header>
			<hr class="m-0" />
			<section class="p-3">
				<InputComponent />
			</section>
			<footer class="p-3">
				<div class="d-flex align-items-center justify-content-end w-100">
					<div class="mr-3">
						<b-button class="new-cancelBtn">Cancel</b-button>
					</div>
					<div><b-button class="new-addBtn">Clone</b-button></div>
				</div>
			</footer>
		</main>
	</b-modal>
</template>

<script>
import InputComponent from "../../../components/InputComponents/Input.vue";

export default {
	name: "cloneTemplateModal",
	data() {
		return {};
	},
	components: {
		InputComponent,
	},
};
</script>
